<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.add') }} {{ $tc('message.activite.titre', 1) }}
          </h3>
        </div>
      </div>

      <div class="card-body p-0">
        <b-form >
          <b-container class="p-0 pt-2">

            <b-row class="justify-content-sm-center">
              <b-col sm="12" class="mb-2">
              <div  v-if="selectedMissions.length > 0">
                <p  class="heading text-center mt-5">{{$tc('message.details',2)}}</p>
                <b-row class="my-2">
                  <b-col sm="12">
                    <b-table
                        striped
                        responsive
                        hover
                        bordered
                        :items="selectedMissions"
                        :fields="selectedMissionsField"
                    >
                      <template v-slot:cell(description)="data">
                        <p class="mb-0">{{ getDescription(data.value) }}</p>
                      </template>
                      <template v-slot:cell(dossier_medical_id)="data">
                        <p class="mb-0">{{ getNomPatient(data.value) }}</p>
                      </template>
                      <template v-slot:cell(action)="data">
                        <b-button @click="supprimerMission(data)"  class="btn-sm btn-outline-danger" >
                          {{ $t('message.delete') }}
                        </b-button>
                      </template>

                      <!--                  <template v-slot:cell(price)="data">-->
                      <!--                    <p class="mb-0 capitalize-first-letter">{{ displayNumber(data.value) }}</p>-->
                      <!--                  </template>-->

                      <!--                  <template v-slot:cell(reduction)="data">-->
                      <!--                    <p class="mb-0 capitalize-first-letter">{{ displayNumber(data.value) }}</p>-->
                      <!--                  </template>-->

                      <!--                  &lt;!&ndash; Optional default data cell scoped slot &ndash;&gt;-->
                      <!--                  <template v-slot:cell()="data">-->
                      <!--                    <p class="mb-0">{{ data.value }}</p>-->
                      <!--                  </template>-->
                    </b-table>
                  </b-col>
                </b-row>
              </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="groupeActivite-group"
                    :label="$t('message.groupeActivite')"
                    label-for="institution"
                >
                  <slim-element return-value="id" selected-id="groupeActivite" :afficher="true" :element.sync="$v.form.groupe_activite.$model" :data.sync="mGroupeActivites"></slim-element>

                  <div class="invalid-feedback" v-if="$v.form.groupe_activite.$error">
                    {{ $t('message.requiredField') }}
                  </div>
                  <span v-if="errorshasField('groupe_activite')" class="custom-invalid">
                                    {{getErrorsField('groupe_activite')}}
                                    </span>
                </b-form-group>

                <div v-if="$v.form.groupe_activite.$model == '1' || $v.form.groupe_activite.$model == '2'">
                  <b-form-group
                      id="patients-group"
                      :label="$t('message.nomPatient')"
                      label-for="patients"
                  >
                    <slim-element return-value="id" selected-id="patients" :afficher="$v.form.groupe_activite.$model === 1 || $v.form.groupe_activite.$model ===2" :element.sync="form.dossier_medical_id" :data.sync="mPatients"></slim-element>
                    <div class="invalid-feedback" v-if="$v.form.dossier_medical_id.$error">
                      {{ $t('message.requiredField') }}
                    </div>
                    <span v-if="errorshasField('dossier_medical_id')" class="custom-invalid">
                                                    {{getErrorsField('dossier_medical_id')}}
                                                    </span>
                  </b-form-group>
                </div>

                <b-form-group
                    id="description-group"
                    :label="$t('message.description')"
                    label-for="description"
                >
                  <slim-element return-value="id" selected-id="descriptions" :afficher="true" :element.sync="$v.form.description.$model" :data.sync="missions"></slim-element>

                </b-form-group>

                <b-form-group  v-if="$v.form.groupe_activite.$model ===3"
                               id="nomPartenaire-group"
                               :label="$t('message.nomPartenaire')"
                               label-for="nom"
                               description=""
                >
                  <b-form-input
                      id="nomPartenaire"
                      v-model="$v.form.nom_partenaire.$model"
                      :state="$v.form.nom_partenaire.$dirty ? !(errorshasField('nom_partenaire') || $v.form.nom_partenaire.$error) : null"
                      type="text"
                      required
                      placeholder=""
                      @focus="clearErrorField('nom_partenaire')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.nom_partenaire.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('nom_partenaire')">
                    {{ getErrorsField('nom_partenaire') }}
                  </b-form-invalid-feedback>

                </b-form-group>

                <b-form-group  v-if="$v.form.groupe_activite.$model ===4"
                               id="nomActivite-group"
                               :label="$t('message.activite.nom')"
                               label-for="nomActivite"
                               description=""
                >
                  <b-form-input
                      id="nomActivite"
                      v-model="$v.form.nom_activite.$model"
                      :state="$v.form.nom_activite.$dirty ? !(errorshasField('nom_activite') || $v.form.nom_activite.$error) : null"
                      type="text"
                      required
                      placeholder=""
                      @focus="clearErrorField('nom_activite')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.nom_activite.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('nom_activite')">
                    {{ getErrorsField('nom_activite') }}
                  </b-form-invalid-feedback>

                </b-form-group>

                <b-form-group
                    id="commentaire-group"
                    :label="$tc('message.commentaires',1)"
                    label-for="commentaire"
                >
                  <div v-if="$v.form.description.$model === '1'">
                    <slim-element return-value="text" selected-id="commentaire" :afficher="$v.form.description.$model === '1'" :element.sync="form.commentaire" :data.sync="commentaireOptions"></slim-element>
                  </div>
                  <b-form-input v-if="$v.form.description.$model !== '1'"
                                id="dateCloture"
                                v-model="$v.form.commentaire.$model"
                                :state="$v.form.commentaire.$dirty ? !(errorshasField('commentaire') || $v.form.commentaire.$error) : null"
                                required
                                @focus="clearErrorField('commentaire')"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="errorshasField('commentaire')">
                    {{ getErrorsField('commentaire') }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <div>
                  <label class="form__label" for="hasDesc">{{ $t('message.missionCloture') }}</label>
                  <div class="toggle">
                    <input id="hasDesc" type="checkbox" v-model="form.statut"/>
                    <label for="hasDesc">
                      <div class="toggle__switch"></div>
                    </label>
                  </div>
                </div>

                <b-form-group
                    id="dateCloture-group"
                    :label="$t('message.dateCloture')"
                    label-for="dateCloture"
                    description="">
                  <b-form-input
                      id="dateCloture"
                      v-model="$v.form.date_cloture.$model"
                      :state="$v.form.date_cloture.$dirty ? !(errorshasField('date_cloture') || $v.form.date_cloture.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('date_cloture')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.date_cloture.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_cloture')">
                    {{ getErrorsField('date_cloture') }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </b-col>
            </b-row>

            <b-row class="justify-content-sm-center">
              <b-button @click="addToMission" variant="dark" v-if="can">
                {{ $t('message.add') }}
              </b-button>
            </b-row>

            <b-row class="justify-content-sm-center">
              <b-col sm="12" class="mt-5">
                <div>
                  <label class="form__label" for="hasDesc">{{ $t('message.activiteCloture') }}</label>
                  <div class="toggle">
                    <input id="hasDesc2" type="checkbox" v-model="form.statut_activite"/>
                    <label for="hasDesc2">
                      <div class="toggle__switch"></div>
                    </label>
                  </div>
                </div>

                <b-form-group
                    id="dateCloture2-group"
                    :label="$t('message.dateCloture')"
                    label-for="dateCloture2"
                    description="">
                  <b-form-input
                      id="dateCloture"
                      v-model="$v.form.date_cloture_activite.$model"
                      :state="$v.form.date_cloture_activite.$dirty ? !(errorshasField('date_cloture') || $v.form.date_cloture_activite.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('date_cloture')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.date_cloture_activite.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_cloture')">
                    {{ getErrorsField('date_cloture') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-row class="justify-content-center" v-if="can">
                  <b-button @click="onSubmit" variant="primary">
                    {{ $t('message.save') }}
                  </b-button>
              </b-row>
            </b-row>
          </b-container>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import SlimSelect from "slim-select";
import AppConfig from "@/constants/AppConfig";
import SlimElement from "@/views/Layout/SlimElement";

export default {
  name: "Add",
  components: {
    SlimElement,
  },
  computed: {
    ...mapGetters(["institutions","userInstitutions", "professions", "specialties", "countries", "errors", 'hasAdminRole',
      'hasGestionnaireRole','hasMedecinControleRole','patients','groupeActivites','hasAssistante']),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
    },

    mPatients: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.patients,['created_at'],['desc']), function(patient) {
        let p = {};

        if((typeof patient.user == 'object') && (!_.isNull(patient.user)) ) {
          if (!_.isNull(patient.dossier)){

            let prenom = patient.user.prenom ? patient.user.prenom : '';
            prenom =  prenom.toLowerCase();
            p.text =  (patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
            p.id = patient.dossier.id;
            if (patient.user.isMedicasure == '1'){
              pArray.push(p);
            }
          }
        }
      });

      return pArray;
    },

    mGroupeActivites:function(){
      let self = this;
      let activite  = _.find(this.groupeActivites,function(activite){

        return activite.slug == self.groupe;
      })

      if (!_.isUndefined(activite)){
        self.form.groupe_activite = activite.id;
      }
      let mArray = [];
      _.forEach(this.groupeActivites, function (activite){
        let m = {id:activite.id, text:activite.nom};
        if(self.form.groupe_activite == 1 || self.form.groupe_activite == 2 ){
          if (m.id == 1 || m.id==2){
            mArray.push(m);
          }
        }
        else if (self.form.groupe_activite == 3){
          if (m.id == 3){
            mArray.push(m);
          }
        }
        else if (self.form.groupe_activite == 4){
          if (m.id == 4){
            mArray.push(m);
          }
        }
      })
      return mArray;
      // return _.omit(this.groupeActivites,'missions');

    },

    missions:function(){
      let self = this;
      let activite =  _.find(this.groupeActivites,function(activite){
        return activite.id == self.form.groupe_activite;
      })

      if (!_.isUndefined(activite)){
        let mArray = [];
        _.forEach(activite.missions, function (mission){
          mArray.push({id: mission.id,text:mission.description});
        });
        return mArray;
      }

      return [];
    },

    selectedMissionsField:function (){
      let self = this;
      let sArray = [];
      sArray.push({key: 'description', label: this.$i18n.t('message.description')});
      sArray.push({key: 'commentaire', label: this.$i18n.tc('message.commentaire',1)});
      sArray.push({key: 'date_cloture', label: this.$i18n.t('message.dateCloture')});
      // if (self.form.groupe_activite === 1 || this.form.groupe_activite === 2){
      //   sArray.push({key: 'dossier_medical_id', label: this.$i18n.t('message.nomPatient')});
      // }
      if (self.form.groupe_activite === 3){
        sArray.push({key: 'nom_partenaire', label: this.$i18n.t('message.nomPartenaire')});
      }
      else if (self.form.groupe_activite === 4){
        sArray.push({key: 'nom_activite', label: this.$i18n.t('message.activite.nom')});
      }
      sArray.push({key: 'action', label: this.$i18n.t('message.action')});
      return sArray;
    }
  },
  data() {
    return {
      patientObject:Object,
      commentaireObject:Object,
      selectedMissions:[],
      groupe:this.$route.params.groupe,
      commentaireOptions:[
        {id:1,text:'Très Urgent : <12h>'},
        {id:2,text:'Urgent : <48h>'},
        {id:3,text:'Normal > 48h'}
      ],
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
      form: {
        dossier_medical_id:'',
        groupe_activite:'',
        nom_activite:'',
        nom_partenaire:'',
        description:'',
        statut:false,
        statut_activite:false,
        commentaire:'',
        date_cloture:'',
        date_cloture_activite:'',
      }
    }
  },
  watch:{

  },
  methods:{
    getDescription(item){
      let mission =        _.find(this.missions, function (mission){
        return mission.id == item
      })

      if (mission){
        return  mission.text;
      }
      return '';
    },

    supprimerMission(item){
      this.selectedMissions.splice(item,1);
    },

    getNomPatient(item){
      let patient =        _.find(this.mPatients, function (patient){
        return patient.id == item
      })

      if (patient){
        return  patient.text;
      }
      return '';
    },

    addToMission(){
      let activite = this.form.groupe_activite;
      this.form.description = parseInt(this.form.description);
      let items = ['description','commentaire','date_cloture','statut']
      if (activite === 1 || activite === 2)
        this.selectedMissions.unshift(_.pick(this.form,items.concat('dossier_medical_id')));
      else if (activite === 3)
        this.selectedMissions.unshift(_.pick(this.form,items.concat('nom_partenaire')));
      else if (activite === 4)
        this.selectedMissions.unshift(_.pick(this.form,items.concat('nom_activite')));

      this.form.commentaire="";
      this.form.nom_activite="";
    },
    getPatients() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPatients', { args : args });
    },

    getGroupeActivites:function (){
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getGroupeActivites', { args : args });
    },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },

    onSubmit(){

      if(this.selectedMissions.length > 0){


        let args = {};

        args.groupe_activite = this.form.groupe_activite;
        args.date_cloture = this.form.date_cloture_activite;
        args.statut = this.form.statut_activite;
        args.missions = this.selectedMissions;

        let successMessage = this.$i18n.t('message.activite.create');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('CreateActivite', { args, errorMessages, successMessage })
      }
    },

    errorshasField(field){
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field){
      this.$store.dispatch('clearErrorField', { field });

      this.getErrorsField(field);
    },
  },
  validations() {
    return {
      form: {
        dossier_medical_id:{},
        groupe_activite:{},
        nom_activite:{},
        nom_partenaire:{},
        description:{},
        statut:{},
        statut_activite:{},
        commentaire:{},
        date_cloture:{},
        date_cloture_activite:{},
      }
    }
  },
  mounted() {
    this.getGroupeActivites();

    this.getPatients();

    new SlimSelect({
      select: '#groupeActivite',
      placeholder: 'Select activity group',
    });

    new SlimSelect({
      select: '#description',
      placeholder: 'Select description',
    });

    // this.commentaireObject =  new SlimSelect({
    //   select: '#commentaire',
    //   placeholder: 'Select commentaire',
    // });
    //
    // this.patientObject =  new SlimSelect({
    //   select: '#patients',
    //   placeholder: 'Select patients',
    // });

  }
}
</script>

<style scoped>

</style>